import { generatePath, Link } from 'react-router-dom'
import { Text } from 'blaze-ui/Text/Text'
import { BRAND_PLAN_SCHEDULE_PATH } from 'paths'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { ContentStrategyTypeLabel } from '../../../../constants'
import { EmojiMap } from 'components/ContentStrategyTypeEmoji/ContentStrategyTypeEmoji'
import { CampaignInfo, ContentStrategyType } from 'types'
import Styles from './CampaignSection.module.scss'

interface CampaignSectionProps {
  campaignInfo: CampaignInfo
  onClose?: () => void
}

const getStrategyLabel = (strategyType: ContentStrategyType | null): string | null => {
  if (!strategyType) return null
  const emoji = EmojiMap[strategyType] || ''
  const label = ContentStrategyTypeLabel[strategyType] || ''
  if (!label) return null
  return `${emoji} ${label}`.trim()
}

export const CampaignSection = ({ campaignInfo, onClose }: CampaignSectionProps) => {
  const workspaceId = useCurrentWorkspaceId()

  const campaignPath = generatePath(BRAND_PLAN_SCHEDULE_PATH, {
    workspaceId,
    scheduleId: campaignInfo.id,
  })
  const strategyLabel = getStrategyLabel(campaignInfo.content_strategy_type)

  return (
    <Link to={campaignPath} className={Styles.card} onClick={() => onClose?.()}>
      <Text variant="placeholder" color="var(--dark-40)">
        Campaign
      </Text>
      <div className={Styles.content}>
        <Text variant="secondary" lineClamp={2}>
          {campaignInfo.title}
        </Text>
        {strategyLabel && (
          <Text variant="metadata" color="var(--dark-60)">
            {strategyLabel}
          </Text>
        )}
      </div>
    </Link>
  )
}
